import { FETCH_LOGIN, FAILED_LOGIN, RECEIVE_LOGIN, FETCH_LOGOUT, RECEIVE_LOGOUT, FETCH_CHECK_AUTH, RECEIVE_CHECK_AUTH } from '../../actions/aUser-Auth.jsx';


const defaultAuthState = {
    authData: null,
    isAuthenticated: false,
    subs: {}  
}
var newAuthState;

export function fetchAuth(state = defaultAuthState, action) {
    switch (action.type) {
        case FETCH_LOGIN: 
            return ({
                authData: null,
                isAuthenticated: false,
                subs: {}
            });
        case RECEIVE_LOGIN:
            newAuthState = action.payload;
            return Object.assign(
                {},
                state,
                newAuthState,
                {
                    authData: newAuthState,
                    subs: action.payload.result.subs,
                    email_verified: action.payload.result.email_verified,
                    isAuthenticated: true
                }
            );
        case FAILED_LOGIN: 
            return ({
                authData: null,
                isAuthenticated: false,
                subs: {}
            });

        // case REHYDRATE:
        //     if(localStorage.getItem("TCNOPlt") === null || localStorage.getItem("TCNOPlt") === undefined) {
        //         return {}
        //     }

        case FETCH_LOGOUT: 
            return ({
                ...state,
            })
        case RECEIVE_LOGOUT:
            newAuthState = null
            return ({
                authData: null,
                isAuthenticated: false
            })
        case FETCH_CHECK_AUTH:
            return ({
                ...state,
                isAuthenticated: false
            })
        case RECEIVE_CHECK_AUTH:
            // console.log(newAuthState);
            if(newAuthState === '[]') {
                return ({
                    authData: null,
                    isAuthenticated: true
                })
            } else if(newAuthState == null) {
                return({
                    ...state,
                    isAuthenticated: false
                });
            } else if(newAuthState != null) {
                return({
                    ...state,
                    isAuthenticated: true
                });
            } else {
                return({
                    ...state,
                    isAuthenticated: true
                });
            }
        default:
            return state;
    }
}